import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Compra } from 'app/obj/compra';
import { CurrencyService } from '../../services/currency.service';
import { CotizadorService } from '../../services/general/cotizador.service';
import { UpgradeService } from '../../services/general/upgrade.service';
import { Pasajero }    from '../../obj/pasajero';

@Component({
  selector: 'app-up-grade',
  templateUrl: './up-grade.component.html',
  styleUrls: ['./up-grade.component.css'],
  providers: [CotizadorService, UpgradeService]
})
export class UpGradeComponent implements OnInit {
  public modelPoliza;
  public modelCotizacion;
  public model;
  public pasajerosUpgrade = [];
  public totalUpgrade = 0;
  public tipos = [''];
  public cantidadDias = 0;
  public upgrade = [];

  constructor(public _currencyService:CurrencyService, public upgradeSrv: UpgradeService, private route: ActivatedRoute,private router: Router,private cs:CotizadorService) { }

  async ngOnInit() {

    // let scripts = new ScriptsModule;
    // scripts.loadScript('assets/js/scripts/solicitar.js');

    var cotizacion= localStorage.getItem('currentCotizacion');
    var poliza= localStorage.getItem('currentPoliza');
    var compra= localStorage.getItem('currentCompra');

    if(compra==null)
        this.model=new Compra();
    else
      this.model=JSON.parse(compra);

    this.route.queryParams.subscribe(params => {
        // Defaults to 0 if no query param provided.
        this.model.tipo = params['IdTipo'] ;
        this.model.id = params['Id'] ;


        if(cotizacion==null )
          this.router.navigate(['/comparar']);
        else {
          this.modelCotizacion=JSON.parse(cotizacion);
          // this.modelCotizacion.pasajerosArray
          // this.pasajerosUpgrade = this.modelCotizacion.pasajerosArray.map(a => {return { ...a, upgrade: []}});
        }
        if(poliza==null) {
          this.router.navigate(['/comparar']);
        } else {
          this.modelPoliza=JSON.parse(poliza);
          this.modelPoliza.totalUpgrade = 0;
        }

        var fechaInicio = new Date(this.validarFormatoFecha(this.modelCotizacion.inicio) ? this.modelCotizacion.inicio.split("/").reverse().join("/"): this.modelCotizacion.inicio).getTime();
        var fechaFin    = new Date(this.validarFormatoFecha(this.modelCotizacion.fin) ? this.modelCotizacion.fin.split("/").reverse().join("/"): this.modelCotizacion.fin).getTime();

        var diff = fechaFin - fechaInicio;

        var cantidadDias = diff/(1000*60*60*24);
        const upgradeAPI = this.upgradeSrv.getUpgradesApi({
          "Viajeros": this.modelCotizacion.pasajerosArrayCopia,
          "DiasViaje": cantidadDias + 1,
          "IdProductoBase": this.modelPoliza.idPoliza.toUpperCase()
        });
        upgradeAPI.then(resp => {
          this.upgrade = resp;
          this.loadPasajeros();

          const ntu = resp.map(a => a.nombreTipoUpgrade)
          this.tipos = ntu.filter((item,index)=>{
            return ntu.indexOf(item) === index;
          })
        }).catch(err =>{
            // this.router.navigate(['/solicitar'], { queryParams: { IdTipo:this.model.tipo ? this.model.tipo: 1, Id: this.model.id } });
        })
    });
  }

  validarFormatoFecha(cadenaFecha) {
    // Expresión regular para validar el formato "DD/MM/YYYY"
    const regexFecha = /^\d{2}\/\d{2}\/\d{4}$/;

    // Verificar si la cadena de fecha cumple con el formato esperado
    if (regexFecha.test(cadenaFecha)) {
        // Si la cadena es válida, realizar el procesamiento adicional aquí
        return true;
    } else {
        // Si la cadena no es válida, manejar el caso de error aquí
        return false;
    }
}



  selectModel(j) {
    // j.montoSelect[p.numero]
  }
  desde(arrayCaracteristicas) {
    if (arrayCaracteristicas) {
        const array = arrayCaracteristicas.split(";").map(a => {
            let s = a.split(":");
            return { id: s[0], cobertura: s[1], valor: s[2] };
        });

        const extractValue = (str) => parseFloat(str.replace(/[^\d.]/g, ''));

        // Obtener el valor mínimo usando reduce
        const menorValor = array.reduce((min, elemento) => {
            const valorActual = extractValue(elemento.valor);
            return valorActual < extractValue(min.valor) ? elemento : min;
        }, array[0]);

        const cantidadSinUS = menorValor.valor.replace("US$", "");
        console.log(cantidadSinUS);
        return extractValue(cantidadSinUS);

    } else {
        return 0;
    }
  }


  arrayCaracteristicas(arrayCaracteristicas){
    if (arrayCaracteristicas) {
        const array = arrayCaracteristicas.split(";").map(a => {
            let s = a.split(":");
            return { id: s[0], cobertura: s[1], valor: s[2]};
        });

        const extractValue = (str) => parseFloat(str.replace(/[^\d.]/g, ''));

        const customComparator = (a, b) => {
            const valueA = extractValue(a.cobertura);
            const valueB = extractValue(b.cobertura);
            return valueA - valueB;
        };

        return array.sort(customComparator);

    } else {
        return [];
    }
  }


  loadPasajeros(){
    try{
        //VALIDAMOS PASAJEROS DE LA COMPRA
        this.model.pasajeros=[];
        const pasajeros = JSON.parse(this.modelCotizacion.pasajerosArray);
        this.upgrade.map(a => { return { ...a, pasajero: []}})

        for(var i =0;i<pasajeros.length;i++){
          try{
            // this.upgrade.map(a => { return { ...a, ['montoPasajero'+i]: ''}})
            var p=new Pasajero(i+1,pasajeros[i].Edad,'','', '', '','','', pasajeros[i].Gender);
            p.edadIngresada=`Ingrese fecha de nacimiento`
            p.style='5px solid red';

            // this.upgrade.map(a => { return { ...a, pasajero: []}})

            this.model.pasajeros.push({...p, upgrade: []});
            this.pasajerosUpgrade.push({...p, upgrade: []});

            if (pasajeros.length == (i+1)) {
              if (this.upgrade.length == 0) {
                this.next();
              }
            }
          }catch(error){}
        }

    }
    catch(error){}
  }

  addUpgradeAllPasajero($event, upgrade) {

    if ($event.target.value == "") {
        let index = 0;
        for (const i of this.model.pasajeros) {
            // for (let j = 0; j < i.upgrade.length; j++) {
            //     i['montoPasajero'] = "";
            //     imonto = "";
            // }

            i.montoPasajero = "";
            i['idMontoPasajero'+upgrade.idProducto] = "";
            if (i.upgrade.find(a => a.idProducto == upgrade.idProducto)) {
                i.upgrade.splice(i.upgrade.findIndex(a => a.idProducto == upgrade.idProducto), 1)
                i.monto = "";
            }

            ++index;

        }
    } else  {
      let index = 0;
      for (const i of this.model.pasajeros) {

        const array = this.arrayCaracteristicas(upgrade.ArrayCaracteristicas);
        const arraySelect = array.find(a => a.id == $event.target.value);
        i.montoPasajero = arraySelect.valor + i.montoPasajero;
        i['idMontoPasajero'+upgrade.idProducto] = arraySelect.id;

        if (!i.upgrade.find(a => a.idProducto == upgrade.idProducto)) {
            if (i.genero == upgrade.generos || upgrade.generos != '1') {
                i.upgrade.push({
                    ...upgrade,
                    idCaracteristicaSelect: arraySelect.id, caracteristicasSelect: arraySelect
                });
                i.monto = $event.target.value;

            }
        } else {
            i.upgrade[i.upgrade.findIndex(a => a.idProducto == upgrade.idProducto)] = {...upgrade, idCaracteristicaSelect: arraySelect.id, caracteristicasSelect: arraySelect}
        }


        // for (let j = 0; j < i.upgrade.length; j++) {
        //   i['montoPasajero'] = $event.target.value;
        //   i['montoPasajero'] = $event.target.value;

        // }
        ++index;
        // this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.push(upgrade);
      }
      // model.pasajeros
    }

    this.precioUpgrade();
  }
  calcularValor() {

  }

  addUpgradePasajero($event, posicion, upgrade, select) {
    const array = this.arrayCaracteristicas(upgrade.ArrayCaracteristicas);
    const arraySelect = array.find(a => a.id == $event.target.value)
    if(!this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.find(a => a.idProducto == upgrade.idProducto)) {
        this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.push({
            ...upgrade, idCaracteristicaSelect: arraySelect.id, caracteristicasSelect: arraySelect
        });
        this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgradeSelect = [];

    } else {
        if($event.target.value == "") {
            this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.splice(this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.findIndex(a => a.Id == upgrade.idProducto), 1)
        } else {
          this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.find(a => a.idProducto == upgrade.idProducto).idCaracteristicaSelect = arraySelect.id;
          this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.find(a => a.idProducto == upgrade.idProducto).caracteristicasSelect = arraySelect;
        }
    }

    this.precioUpgrade();

  }

  precioUpgrade() {
    let precios = 0;
    let index = 0;
    let valor = 0;
    for (const i of this.model.pasajeros) {
        for (const j of i.upgrade) {
            valor += parseInt(j.caracteristicasSelect.valor);
        }
    }
    this.modelPoliza.totalUpgrade = valor * this.modelPoliza.trm
  }

  quitarUpgrade(posicion, upgrade) {
    for (let i = 0; i < this.model.pasajeros.length; i++) {
      this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.find(a => a.idProducto == upgrade.idProducto)['montoPasajero'+i] = "";
      this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.find(a => a.idProducto == upgrade.idProducto)['monto'] = "";
    }
    this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.splice(this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.findIndex(a => a.idProducto == upgrade.idProducto), 1)
    this.precioUpgrade();
  }



  showDetail(id: string) {

    // (1000*60*60*24) --> milisegundos -> segundos -> minutos -> horas -> días
    // this.upgradeSrv.upgradeDetail({Id: id, cantidadDias});
  }


  conversionMonedas(indice:String) {
    let poliza = this.modelPoliza;

    if(poliza) {

        if(this.modelPoliza.conversionMoneda) {
            let coleccion = this.modelPoliza.conversionMoneda;
            let item = coleccion.filter(x => x.id == indice)[0];
            this._currencyService.setValor(item.valor);

            return item.valor;
        }
    }
  }
  setgenero(val) {
    if (val == 0) {
      return 'Masculino'
    } else if(val == 1) {
      return 'Femenino'
    } else {
      return 'No binario'
    }
  }


  next(){
    let upgradeSelect = []
    for (const i of this.pasajerosUpgrade) {
      if (i.upgrade.length > 0) {
        upgradeSelect = [...i.upgrade];
      }
    }
    localStorage.setItem('currentCotizacion',JSON.stringify(this.modelCotizacion));
    localStorage.setItem('currentPoliza',JSON.stringify(this.modelPoliza));
    localStorage.setItem('currentCompra',JSON.stringify(this.model));
    if (this.model.id && this.model.tipo) {
        this.router.navigate(['/solicitar'], { queryParams: { IdTipo:this.model.tipo, Id: this.model.id } });
    } else {
        this.router.navigate(['/solicitar'], { queryParams: { IdTipo:1} });
    }

  }
}




// WEBPACK FOOTER //
// ./src/app/components/up-grade/up-grade.component.ts